import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';

import { Card } from '../../../components/Card';
import { Loader } from '../../../components/Loader';
import { Notification } from '../../../components/Notification';

import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { fetchCompanyInvoices } from '../../Invoices/actions';
import { REQUEST_COMPANY_INVOICES } from '../../Invoices/constants';
import { checkVies, syncExactId, toggleNotification } from '../actions';
import env from '../../../env';

import styles from './detailsColumns.module.css';
import cn from 'classnames';

import { REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE } from '../constants';

import { TransportOrderInfoCard } from '../components/CardInfo';

import { TransportOrderClientCard } from '../components/CardClientDetails';

import { TransporterInfoCard } from '../components/CardTransporterInfo';
import { TransportOrderStatusesCard } from '../components/CardTransportOrderStatuses';

import { TransportOrderCreateModal } from '../components/createTransportOrder';
import { TransportOrderClientFromCard } from '../components/CardClientFromDetails';

//comment1
const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
  }

  .info-card.wide {
    width: 99%;
  }

  .info-card-fin.wide {
    width: 99%;
  }

  .company-info-card info-card {
    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      width: 100%;
      margin: 6px 0;
    }
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 49% 49%;
  gap: 10px;
  width: 100%;
  @media (max-width: 1440px) {
    gap: 5px;
    width: 100%;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;

    & > div {
      width: 100%;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class TransportOrderDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    // this.props.fetch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.notification?.isShow) {
      this._t = this.timeout(
        () => {
          this.props.toggleNotification();
        },
        5000,
        this._t,
      );
    }
  }

  get transportOrder() {
    return this.props.transportOrder;
  }

  get clientCompanyTo() {
    const companyTo =
      this.transportOrder?.companyTo;

    return companyTo;
  }

  get clientCompanyFrom() {
    const companyFrom =
      this.transportOrder?.companyFrom;

    return companyFrom;
  }

  handleSync = () => {
    this.props.syncExactId(this.props.company.id);
  };

  renderThirdColumn(company) {
    return <></>;
  }

  render() {
    const companyTo = this.clientCompanyTo;
    const companyFrom = this.clientCompanyFrom;

    if (this.props.work) return <Loader small />;

    return (
      <Container className={styles.containerPage}>
        {this.props.notification?.isShow == '1' && (
          <Notification>{this.lbl(`company.create.${this.props.notification?.message}`)}</Notification>
        )}

        <VBox left className={cn('col', styles.firstColumn)} top>
          <TransportOrderInfoCard transportOrder={this.transportOrder} />
        </VBox>

        <VBox left className="col" top>
          <>
            <Wrapper>
              <VBox top>
              <TransportOrderClientFromCard companyTo={companyTo} companyFrom={companyFrom} />
                <TransportOrderClientCard companyTo={companyTo} companyFrom={companyFrom} />
              
                <TransporterInfoCard transporter={this.transportOrder?.transporter} />
              </VBox>

              <VBox top>
                <TransportOrderStatusesCard transportOrder={this.transportOrder} transporter={this.transportOrder?.transporter}/>
                {/* {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <TransportOrderRemarksCard transportOrder={this.transportOrder} loggedUserId={this.props.loggedInUserId} />
                )} */}
                <Card className="company-info-card info-card data">
                  <TransportOrderCreateModal
                    vehicle={this.props.transportOrder?.vehicle}
                    transportOrderId={this.transportOrder?.id}
                    from_location={'editPage'}
                  />
                </Card>
              </VBox>
            </Wrapper>
          </>
        </VBox>

        {window.innerWidth > 1400 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.company)}
          </VBox>
        )}

        {window.innerWidth < 748 && (
          <VBox left className={cn('col align-items-end', styles.thirdColumn)} top>
            {this.renderThirdColumn(this.props.company)}
          </VBox>
        )}
      </Container>
    );
  }
}

TransportOrderDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY_INVOICES]),
    workRemarks: selectWork(`${REQUEST_TRANSPORT_ORDER_PROPERTY_UPDATE}-remarks`),
    loggedInUserId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    syncExactId(companyId) {
      dispatch(syncExactId(companyId));
    },
    fetch(callback) {
      dispatch(fetchCompanyInvoices(ownProps.company?.id));
    },
    fetchVies(dto, callback) {
      dispatch(checkVies(ownProps.company?.id, dto, callback));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderDetailsColumns = compose(withConnect, withRouter)(TransportOrderDetailsColumnsComp);
